import { IAppConfig, IAppEndpoint } from '@rccl/telemetry-events';
import { API_PATH, ENDPOINTS, ENV_CONFIG } from '~environments/environment';

const BRAND_REGEX = '(royal|celebrity)';
const LANGUAGE_REGEX = '(en|es|pt)';
const SHIP_CODE_REGEX = '[a-zA-Z]{2}';
const NUMERIC_DATE_REGEX = '[0-9]{8}';
const CHANNEL_REGEX = '(web)';
const VDSID_REGEX = '.{2,100}';
const VOYAGES_REGEX = '[A-Z]{2}[0-9]{8}';

// Endpoints that are getting tracked

export const telemetryEndpoints = [
  {
    method: 'GET',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_SAILING_INFORMATION_ENRICHED}/`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'searchSailingsEnriched',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'GET',
    path: `/`,
    pathRegex: `${ENDPOINTS.API_MICROSERVICE_PROFILE_BOOKINGS}/${VDSID_REGEX}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'profileBookingsByVdsId',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}${ENDPOINTS.API_MICROSERVICE_BEGIN_DETAILS}/${VDSID_REGEX}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'getSelectedGuestDetails',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'GET',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}${ENDPOINTS.API_GOVERNANCE_CONTENT}/${SHIP_CODE_REGEX}/${NUMERIC_DATE_REGEX}`,
    server: API_PATH,
    service: 'gobernance',
    operation: 'getGovernanceContent',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_DELETE_AUTHORIZED_CONSENTS}/${VDSID_REGEX}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'postAuthorizedConsents',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_CREATE_UPDATE_TRAVEL_QUESTIONNAIRE}/${VDSID_REGEX}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'postCreateUpdateQuestionnaire',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_RETRIEVE_TRAVEL_QUESTIONNAIRE}/${VDSID_REGEX}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'postGetTravelQuestionnaire',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 2
  },
  {
    method: 'POST',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_RETRIEVE_CHECKIN_STATUS}/${VDSID_REGEX}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'getCheckInStatuses',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 2
  },
  {
    method: 'POST',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}${ENDPOINTS.API_MICROSERVICE_GUEST_END_SESSION}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'guestLifecycleSession',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: '/',
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_RETRIEVE_ONBOARD_PAYMENT}/${VDSID_REGEX}${ENDPOINTS.API_MICROSERVICE_SEARCH}`,
    server: API_PATH,
    service: 'guestCheckIn',
    operation: 'getOnboardPayment',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: '/',
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_CREATE_UPDATE_ONBOARD_PAYMENT}/${VDSID_REGEX}/${ENDPOINTS.API_MICROSERVICE_SAVE_ONBOARD_PAYMENT}`,
    server: API_PATH,
    service: 'guestCheckIn',
    operation: 'createUpdateOnboardPayment',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: '/',
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}${ENDPOINTS.API_MICROSERVICE_BOARDINGPASS}/${VDSID_REGEX}`,
    server: API_PATH,
    service: 'guestCheckIn',
    operation: 'getSetSailPass',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 2
  },
  {
    method: 'POST',
    path: '/',
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}${ENDPOINTS.API_MICROSERVICE_ARRIVAL_APPOINTMENTS}/${VDSID_REGEX}${ENDPOINTS.API_MICROSERVICE_ARRIVAL_INVENTORY}`,
    server: API_PATH,
    service: 'guestCheckIn',
    operation: 'getArrivalAppointment',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: '/',
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}${ENDPOINTS.API_MICROSERVICE_ARRIVAL_APPOINTMENTS}/${VDSID_REGEX}`,
    server: API_PATH,
    service: 'guestCheckIn',
    operation: 'postArrivalAppointment',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_CREATE_UPDATE_AUTHORIZED_CONSENTS}/${VDSID_REGEX}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'postAuthorizedConsents',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_CREATE_UPDATE_GUEST_INFORMATION}/${VDSID_REGEX}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'postGuestInformation',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_POST_SURVEY}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'postGuestInformation',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'GET',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_GET_PERSONAL_DETAIL_CONTENT}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'getPersonalDetailsContent',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_POST_VALIDATE_LOYALTY}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'postValidateLoyaltyNumber',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_GET_SECURITY_PHOTO_LIST}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'getPhotoList',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'GET',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/web/v3/ships/voyages/${VOYAGES_REGEX}/enriched`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'getSailingInformation',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_POST_RETRIEVE_CRUISE_SURVEY}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'postRetrieveCruiseSurvey',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'POST',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_POST_SAVE_CRUISE_SURVEY}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'postSaveCruiseSurvey',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
  {
    method: 'GET',
    path: `/`,
    pathRegex: `/${LANGUAGE_REGEX}/${BRAND_REGEX}/${CHANNEL_REGEX}${ENDPOINTS.API_MICROSERVICE_GET_COUNTRIES}`,
    server: API_PATH,
    service: 'guestCheckin',
    operation: 'getCOuntries',
    env: ENV_CONFIG.TELEMETRY.APP_ENV,
    version: 1
  },
] as IAppEndpoint[];

export const telemetryConfig: IAppConfig = {
  appKey: ENV_CONFIG.APIGEE_APP_KEY,
  appId: ENV_CONFIG.TELEMETRY.APP_ID,
  appEnv: ENV_CONFIG.TELEMETRY.APP_ENV,
  appVers: '2021.01.28.1',
  batch: {
    batchSize: ENV_CONFIG.TELEMETRY.BATCH.SIZE,
    isEnabled: ENV_CONFIG.TELEMETRY.BATCH.ENABLED
  },
  debug: {
    isEnabled: ENV_CONFIG.TELEMETRY.DEBUG.ENABLED,
    isVerbose: ENV_CONFIG.TELEMETRY.DEBUG.VERBOSE,
    isConsoleCollapsed: ENV_CONFIG.TELEMETRY.DEBUG.CONSOLE_COLLAPSED
  },
  trackingUrl: ENV_CONFIG.TELEMETRY.TRACKING_URL,
  endpoints: telemetryEndpoints,
  disableTelemetry: ENV_CONFIG.TELEMETRY.DISABLED,
  vdsId: ''
};